import React from "react";
import { Trans } from "react-i18next";

export const EmptyState = () => (
  <div className="emptystate-wrapper is-shown">
    <h2><Trans>No Vehicles</Trans></h2>
    <img src="images/emptystate-icons/newvehicle-emptystate-icon.png" style={{ height: "78px" }} />
    <p className="mb-16"><Trans>Lookings like you haven't added any vehicles yet.</Trans></p>
    <a className="button primary px-32">
      <img src="images/png-icons/addvehicle-white.png" style={{ width: "20px" }} className="float-left mt-8 mr-8" />
      <Trans>Add Vehicle</Trans>
    </a>
  </div>
);
